(function(global) {
    'use strict';
    
    var lib = global.lib || (global.lib = {}),
        cjs = global.createjs || (global.createjs = {}),
        mms = global.mms || (global.mms = {});
    
    function Main() {
        this.__parent__.apply(this, arguments);
        
        this.on("added", this._added, this);
        this.on("mousedown", this._mousedown, this);
    }
    Main.IDLE_TIMEOUT = 120000;
    Main.IDLE2_TIMEOUT = 1500;
    Main.prototype = {
        _added: function() {
            if (typeof this._idleId === "undefined") {
                mms.state.startHighlight();
                this._startIdleTimer(Main.IDLE_TIMEOUT);
            }
        },
        _mousedown: function() {
            this._startIdleTimer(Main.IDLE_TIMEOUT);
        },
        _startIdleTimer: function(delay) {
            if (this._idleId) {
                clearTimeout(this._idleId);
            }
            this._idleId = setTimeout(_.bind(this._idle, this), delay);
        },
        _idle: function() {
            mms.state.goBack();
            if (mms.state.painting) {
                this._startIdleTimer(Main.IDLE2_TIMEOUT);
            }
        }
    };

    lib.mms_Canvas = cjs.extend2(lib.mms_Canvas, Main);

})(this);
